/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'arrow-left-old': {
    width: 16,
    height: 16,
    viewBox: '0 0 34 34',
    data: '<path pid="0" d="M25.2 31.3c.4.4.4 1 0 1.4-.4.4-1 .4-1.4 0l-15-15c-.4-.4-.4-1 0-1.4l15-15c.4-.4 1-.4 1.4 0 .4.4.4 1 0 1.4L10.9 17l14.3 14.3z"/>'
  }
})
